var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19940_20329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.83333C4.5 6.06345 4.31345 6.25 4.08333 6.25C3.85321 6.25 3.66667 6.06345 3.66667 5.83333C3.66667 5.60321 3.85321 5.41667 4.08333 5.41667C4.31345 5.41667 4.5 5.60321 4.5 5.83333Z",
    stroke: "white",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.0003C4.5 10.2304 4.31345 10.417 4.08333 10.417C3.85321 10.417 3.66667 10.2304 3.66667 10.0003C3.66667 9.77021 3.85321 9.58366 4.08333 9.58366C4.31345 9.58366 4.5 9.77021 4.5 10.0003Z",
    stroke: "white",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.1663C4.5 14.3965 4.31345 14.583 4.08333 14.583C3.85321 14.583 3.66667 14.3965 3.66667 14.1663C3.66667 13.9362 3.85321 13.7497 4.08333 13.7497C4.31345 13.7497 4.5 13.9362 4.5 14.1663Z",
    stroke: "white",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4654 9.16699H7.36536C6.93274 9.16699 6.58203 9.5177 6.58203 9.95033V10.0503C6.58203 10.4829 6.93274 10.8337 7.36536 10.8337H17.4654C17.898 10.8337 18.2487 10.4829 18.2487 10.0503V9.95033C18.2487 9.5177 17.898 9.16699 17.4654 9.16699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4654 13.333H7.36536C6.93274 13.333 6.58203 13.6837 6.58203 14.1163V14.2163C6.58203 14.649 6.93274 14.9997 7.36536 14.9997H17.4654C17.898 14.9997 18.2487 14.649 18.2487 14.2163V14.1163C18.2487 13.6837 17.898 13.333 17.4654 13.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4654 5H7.36536C6.93274 5 6.58203 5.35071 6.58203 5.78333V5.88333C6.58203 6.31596 6.93274 6.66667 7.36536 6.66667H17.4654C17.898 6.66667 18.2487 6.31596 18.2487 5.88333V5.78333C18.2487 5.35071 17.898 5 17.4654 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19940_20329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.f6d8340237ff7df24d449158f5ef60d7.svg";
export { ForwardRef as ReactComponent };